<div class="pricing-modal">
  <button class="close-btn" aria-label="Close" (click)="close()">
    <i class="bi bi-x-lg"></i>
  </button>
      <h2 class="title text-center">Delete {{title}}</h2>
  <p class="text-center">
    This will permanently delete {{title | lowercase}} 
    <strong>{{rulesetName ? rulesetName : ''}}</strong>
    This action cannot be undone.
  </p>
  <div class="d-flex justify-content-center gap-4">
  <button  type="button" class="btn-add cancel" (click)="close()">
    Cancel 
  </button>
  <button type="button" class="btn-add" (click)="delete()">
    Delete
  </button>
  </div>
</div>
